const en = {
  previewAlt: 'Preview',
  empty: 'No image',
  dropHint: 'Drop to upload',
  upload: 'Upload…',
  useLink: 'Use a link',
  removeLabel: 'Remove image',
  urlLabel: 'Image URL',
  loading: 'Loading image…',
  errors: {
    invalidUrl: 'Please enter a valid URL',
    loadFailed: 'Failed to load image',
    notAnImage: 'Drop an image file',
  },
};

const fr: typeof en = {
  previewAlt: 'Aperçu',
  empty: 'Aucune image',
  dropHint: 'Déposez pour importer',
  upload: 'Importer…',
  useLink: 'Utiliser un lien',
  removeLabel: "Retirer l'image",
  urlLabel: "URL de l'image",
  loading: "Chargement de l'image…",
  errors: {
    invalidUrl: 'Veuillez saisir une URL valide',
    loadFailed: "Impossible de charger l'image",
    notAnImage: 'Déposez un fichier image',
  },
};

const messages = { en, fr };
export default messages;
